; (function () {
    'use strict'
    EMRAdmin.factory('WebSocketHandlerFactory', WebSocketHandlerFactory);

    WebSocketHandlerFactory.$inject = ['EMRCommonFactory', 'errorLogService', '$injector', '$timeout'];

    function WebSocketHandlerFactory(EMRCommonFactory, errorLogService, $injector, $timeout) {
        // Create our websocket object with the address to the websocket
        var fingerPrintForCurrentBrowserDevice;
        var EHRCentralizerConnectionId = adminGetGUID();
        var EHRChatCentralizerWebSocketConnection, EHRChatWebSocketReconnectionCount = 0;
        var ehrChatWebSocketCentralizerMessagesInLockoutMode = [];
        var EHRCentralizerCurrentChatUserSessionCount = 0;
        const EHRCentralizerSocketReadyState = Object.freeze({
            CONNECTING: 0,
            OPEN: 1,
            CLOSING: 2,
            CLOSED: 3
        });
        function initializeChatWebSocketConnection(reInitData) {
            if (EMREmergencyModelDetails && EMREmergencyModelDetails.isEmergencyWeb == true) {
                return;
            }
            let webSocketUrlToConnect = EMRPracticeModel.emrurlsmodel.EMRCentralizerSocketSecondaryURL || EHRCentralizerSocketURL;
            //checking whether the connection is establishning or already opened then no need re connect or re initialize the connection
            if (EHRChatCentralizerWebSocketConnection && (EHRChatCentralizerWebSocketConnection.readyState == EHRCentralizerSocketReadyState.CONNECTING || EHRChatCentralizerWebSocketConnection.readyState == EHRCentralizerSocketReadyState.OPEN)) {
                return;
            }
            EHRChatCentralizerWebSocketConnection = new WebSocket(webSocketUrlToConnect);

            var ehrCentralizerInfo = {};
            ehrCentralizerInfo.PracticeID = EMRPracticeModel.PracticeID;
            ehrCentralizerInfo.FromUserID = EMRPracticeModel.LoggedUserID;
            ehrCentralizerInfo.Type = EHRCentralizerMessageTypes.EHRCentralizerJoin;//for joining the sesssion
            ehrCentralizerInfo.FromUserName = EMRPracticeModel.FirstName + " " + EMRPracticeModel.LastName;

            ehrCentralizerInfo.AppUserName = EMRPracticeModel.LoggedUserName;

            if (EMRPracticeModel.ApplicationType == 2) {
                ehrCentralizerInfo.FromUserName = EMRPracticeModel.LoggedUserName;
                ehrCentralizerInfo.AppUserName = EMRPracticeModel.PortalUserName;
            }


            ehrCentralizerInfo.DateTime = new Date();
            ehrCentralizerInfo.MessageText = ehrCentralizerInfo.FromUserName + " has logged in";
            //on connection opened sending the user info to start to add into connection uusers list
            //on connection opened sending the user info to start to add into connection uusers list
            EHRChatCentralizerWebSocketConnection.onopen = function () {

                if (EHRChatCentralizerWebSocketConnection.readyState == EHRCentralizerSocketReadyState.OPEN) {
                    //setting the connections count to 0 
                    EHRChatWebSocketReconnectionCount = 0;
                    //when there is no finger print for the device
                    if (!hasValue(fingerPrintForCurrentBrowserDevice) && !(EMRPracticeModel.PracticeID === 319 && [2129, 1408, 1409, 1843, 2207, 337].includes(EMRPracticeModel.LoggedUserID))) {
                        $timeout(function () {
                            try {
                                var options = {
                                    excludeAvailableScreenResolution: true,
                                    excludeScreenResolution: true, excludePixelRatio: true
                                };
                                new Fingerprint2(options).get(function (result, components) {
                                    fingerPrintForCurrentBrowserDevice = result;
                                    OnChatWebSocketConnectionOpen(ehrCentralizerInfo, reInitData);
                                });
                            }
                            catch (ex) {
                                OnChatWebSocketConnectionOpen(ehrCentralizerInfo, reInitData);
                                EMRCommonFactory.sendErrorMailOnWebSocketConnectionFailure({ reason: ex.toString() }, webSocketUrlToConnect);
                            }
                        }, 0, false);
                    }
                    else
                        OnChatWebSocketConnectionOpen(ehrCentralizerInfo, reInitData);

                }
                else {
                    //calling to reinitialize the web socket conection
                }
            };



            //on recieving the message from the centralizer
            EHRChatCentralizerWebSocketConnection.onmessage = function (message) {
                //sending the recieved dat to the centralizer method
                ChatWebSocketListener(JSON.parse(message.data));
            };

            //on Error connecting to the Web socket centralizer need to try again for connecting
            EHRChatCentralizerWebSocketConnection.onerror = function (message) {
                //place error handling code if you need
            };

            //on Error connecting to the Web socket centralizer need to try again for connecting
            EHRChatCentralizerWebSocketConnection.onclose = function (message) {

                if (EHRChatCentralizerWebSocketConnection.readyState == EHRCentralizerSocketReadyState.CLOSED || EHRChatCentralizerWebSocketConnection.readyState == EHRCentralizerSocketReadyState.CLOSING) {
                    EHRChatWebSocketReconnectionCount += 1;
                    EMRCommonFactory.logWebSocketFailedDataInWebServer(message);
                    let reconnectionTime = EHRChatWebSocketReconnectionCount;
                    //calling to reinitialize the web socket conection
                    if (EHRChatWebSocketReconnectionCount > 4) reconnectionTime = 5 * 60;
                    if (EHRChatWebSocketReconnectionCount === 4)
                         EMRCommonFactory.sendErrorMailOnWebSocketConnectionFailure(message, webSocketUrlToConnect);
                    setTimeout(function () {
                        initializeChatWebSocketConnection();
                    }, 1000 * reconnectionTime);
                };

            };
        };
        function OnChatWebSocketConnectionOpen(ehrCentralizerInfo, reInitData) {
            //Send message to server that user has joined
            ChatWebSocketSendRequest(ehrCentralizerInfo);

            //SENDING THE PREVIOUS LOCKED MESSAGE INFORMATION WHILE RE CONNECTING TO SOCKET CENTRALIZER
            if (reInitData)
                ChatWebSocketSendRequest(reInitData);
        };
        function ChatWebSocketSendRequest(request) {

            if (request) {

                if (EMRPracticeModel && EMRPracticeModel.PracticeID == 467 && request.Type && (typeof (request.Type)) != "number") {
                    var errorMailoBj = {
                        ErrorMessage: "Message Type is Not a Number",
                        RequestExecutionStatus: -1,
                        isAPI_RequestErrors: true,

                    }
                    errorLogService.errorLogServiceSendErrorMail(errorMailoBj);
                    return;
                }
                //SENDING THE CURRENT PRACTICE ID AND CONNECTION ID AS OVERRIDING
                request.PracticeID = EMRPracticeModel.PracticeID;
                request.ConnectionId = EHRCentralizerConnectionId;//assigning the current connection id for the current instance login
                request.ApplicationType = EMRPracticeModel.ApplicationType;

                request.AppUserName = EMRPracticeModel.LoggedUserName;

                if (EMRPracticeModel.ApplicationType == 2) {
                    request.AppUserName = EMRPracticeModel.PortalUserName;
                }

                if (!request.FromUserID)
                    request.FromUserID = EMRPracticeModel.LoggedUserID;

                //when there is no finger print for the device
                if (fingerPrintForCurrentBrowserDevice)
                    request.DeviceFingerPrint = fingerPrintForCurrentBrowserDevice;

                //checking for connection opened or not then only sending the request
                if (EHRChatCentralizerWebSocketConnection && EHRChatCentralizerWebSocketConnection.readyState == EHRCentralizerSocketReadyState.OPEN) {
                    //sending the reuest to the centralizer
                    EHRChatCentralizerWebSocketConnection.send(JSON.stringify(request));
                    //return defer.promise;
                }
                //TRYING TO RE CONNECT WHEN SOCKET CONNECTION IS CLOSED
                else if (EHRChatCentralizerWebSocketConnection && EHRChatCentralizerWebSocketConnection.readyState == EHRCentralizerSocketReadyState.CLOSED) {
                    //calling to reinitialize the web socket conection
                    initializeChatWebSocketConnection(request);
                }
            }

        };
        function ChatWebSocketListener(data, isFromProcessing) {
            if (!data) return;
            var ehrChatFactory = $injector.get('ehrChatFactory');
            if ($("body").hasClass("fadeehrsession")) {

                if (hasValue(data.Type) && (!hasValue(isFromProcessing) || isFromProcessing == false))
                    ehrChatWebSocketCentralizerMessagesInLockoutMode.push(data); //TODO

                return;
            }
            var messageObj = data;
            switch (messageObj.Type) {
                case EHRCentralizerMessageTypes.EHRCentralizerJoin:
                    messageObj.isFromCentralizedJoin = true;
                    ehrChatFactory.onChatJoin(messageObj, false, true);
                    break;
                case EHRCentralizerMessageTypes.EHRChatUsersList:
                    ehrChatFactory.onUsersList(messageObj);
                    break;
                //when a new message has arrived for the user
                case EHRCentralizerMessageTypes.EHRChatSendMessageToMultipleUsers: //
                case EHRCentralizerMessageTypes.EHRChatSend: //
                    ehrChatFactory.onChatMessage(messageObj);
                    break;
                //new message broadcasted
                case EHRCentralizerMessageTypes.EHRChatBroadcast:
                    ehrChatFactory.onChatMessage(messageObj);
                    break;
                case EHRCentralizerMessageTypes.EHRMessagesForMultipleInstances:
                    if (adminIsDevice()) {
                        return;
                    }
                    //assigning the no.of session users count of the current logged practice user
                    if (hasValue(messageObj) && hasValue(messageObj.MessageText)) {
                        EHRCentralizerCurrentChatUserSessionCount = parseInt(messageObj.MessageText);
                    }

                    break;

                //when a user has left the chat application in the practice
                case EHRCentralizerMessageTypes.EHRChatLeave:
                    ehrChatFactory.onLeave(messageObj);
                    break;

                case EHRCentralizerMessageTypes.EHRMakeVideoCall:
                    ehrChatFactory.OnRecieveVideoCall(data);
                    break;

                case EHRCentralizerMessageTypes.EHRRejectedVideoCall:
                    ehrChatFactory.OnRejectVideoCall(data);
                    break;

                case EHRCentralizerMessageTypes.EHRAcceptVideoCall:
                    ehrChatFactory.OnAcceptedVideoCall(data);
                    break;
                case EHRCentralizerMessageTypes.EHRStopVideoCallInitiated:
                    ehrChatFactory.OnStopVideoCallByHostUser(data);
                    break;
                case EHRCentralizerMessageTypes.EHRGroupChatCreationRefresh:
                    ehrChatFactory.loadAllGroups(data);
                    break;
                case EHRCentralizerMessageTypes.EHRGroupChatNewMemberAdditionRefresh:
                    ehrChatFactory.addNewMemberstoExistingChatGroup(data);
                    break;
                case EHRCentralizerMessageTypes.EHRGroupChatNameChangeRefresh:
                    ehrChatFactory.onChangeEhrGroupChatName(data);
                    break;
                case EHRCentralizerMessageTypes.EHRGroupChatDeletionRefresh:
                    ehrChatFactory.onGroupChatDelete(data);
                    break;
                case EHRCentralizerMessageTypes.EHRGroupChatNewMessageSentRefresh:
                    ehrChatFactory.onGroupChatMessage(data);
                    break;
                case EHRCentralizerMessageTypes.EHRGroupChatMessageDeletionRefresh:
                    ehrChatFactory.onGroupChatMessagesDelete(data);
                    break;
                case EHRCentralizerMessageTypes.EHRChatRemoveUser:
                    ehrChatFactory.removeEhrChatNotCustomizedUser(data);
                    break;
                //a chat window was closed on another session of the same logged user - mirror that close here
                case EHRCentralizerMessageTypes.EHRChatWindowCloseRefresh:
                    ehrChatFactory.onRemoteChatWindowClose(data);
                    break;
                default:
                    break;
            }
        };
        function ProcessLockoutModeChatCentralizerMessages() {

            if (_.isEmpty(ehrChatWebSocketCentralizerMessagesInLockoutMode)) return;

            var ignoreUniqueList = [
                EHRCentralizerMessageTypes.EHRChatLeave,
                EHRCentralizerMessageTypes.EHRCentralizerJoin,
                EHRCentralizerMessageTypes.EHRChatUsersList,
                EHRCentralizerMessageTypes.EHRChatBroadcast,
                EHRCentralizerMessageTypes.EHRChatSend,
                EHRCentralizerMessageTypes.EHRGroupChatNewMemberAdditionRefresh,
                EHRCentralizerMessageTypes.EHRGroupChatNameChangeRefresh,
                EHRCentralizerMessageTypes.EHRGroupChatDeletionRefresh,
                EHRCentralizerMessageTypes.EHRGroupChatNewMessageSentRefresh,
                EHRCentralizerMessageTypes.EHRGroupChatMessageDeletionRefresh,
                EHRCentralizerMessageTypes.EHRChatRemoveUser,
                EHRCentralizerMessageTypes.EHRChatWindowCloseRefresh
            ];

            var distinctMessagesTypes = _.uniq(_.map(ehrChatWebSocketCentralizerMessagesInLockoutMode, 'Type'));


            _.forEach(distinctMessagesTypes, function (eachType) {
                var filteredList = _.filter(ehrChatWebSocketCentralizerMessagesInLockoutMode, function (eachMessage) {
                    return eachMessage.Type == eachType;
                });
                //sending the latest message as the data is automatically adding to list
                if (_.size(filteredList)) {

                    if (ignoreUniqueList.indexOf(eachType) > -1) {

                        _.forEach(filteredList, function (itemInLoop) {
                            //calling the listner to refresh the socket messages
                            ChatWebSocketListener(itemInLoop, true);
                        });

                    }
                    else {
                        //calling the listner to refresh the socket messages
                        ChatWebSocketListener(_.last(filteredList), true);
                    }

                    //as the data has successfully refreshed then removing it from array
                    _.remove(ehrChatWebSocketCentralizerMessagesInLockoutMode, { Type: eachType });
                }
            });
        };
        function removeQBAccountWhileLogout() {

            var ehrChatFactory = $injector.get('ehrChatFactory');

            //calling to remove the QB Account while loggin out the session, and if there is only one user exists in the web socket connection sessions
            if (EHRCentralizerCurrentChatUserSessionCount <= 1)
                ehrChatFactory.removeQBAccountWhileLogout();
        };
        return {
            ChatWebSocketSendRequest,
            initializeChatWebSocketConnection,
            ProcessLockoutModeChatCentralizerMessages,
            removeQBAccountWhileLogout,
            //unique id for the current browser tab / instance - used to ignore our own messages echoed back by the centralizer
            getCentralizerConnectionId: function () { return EHRCentralizerConnectionId; }
        }
    };

})();